// de_pms_billing.ts
// Tłumaczenia dla PMS.Billing.tsx

export const dePmsBilling = {

  title:       "Abrechnung",
  description: "Gastfolios, geteilte Abrechnung, Rueckerstattungen, Korrekturen, Rechnungen und Fiskalbereitschaft.",

  // ── Sekcje ───────────────────────────────────────────────────────────────
  sections: {
    folioWorkspace:      "Folio-Arbeitsbereich",
    folioActivity:       "Folio-Aktivitaet",
    postCharges:         "Gebuehren buchen",
    refundsAdjustments:  "Rueckerstattungen und Korrekturen",
    invoicesFiscal:      "Rechnungen und Fiskalwesen",
    groupBillingSnapshot:"Uebersicht der Gruppenabrechnung",
  },

  // ── Opisy sekcji ─────────────────────────────────────────────────────────
  descriptions: {
    chargeWorkflow:  "Gebuehren buchen, Abrechnung, Rechnungsstellung und Korrekturworkflow.",
    currentItems:    "Aktuelle Positionen, Zahlungen und Rueckerstattungen fuer das ausgewaehlte Folio.",
    controlledReversal:"Kontrollierter Storno- und Korrekturworkflow.",
    partialPayments: "Teil- und Split-Zahlungen ueber mehrere Zahlungsmethoden.",
    generateInvoice: "Rechnung erstellen und ueber die Fiskalintegration weiterleiten.",
    groupFolioSummary:"Die Zusammenfassung des Gruppenfolios bleibt verfuegbar.",
  },

  // ── Metody płatności ──────────────────────────────────────────────────────
  paymentMethods: {
    card:      "Karte",
    cash:      "Barzahlung",
    noPayment: "Keine Zahlung",
    methodOne: "Zahlungsmethode 1",
    methodTwo: "Zahlungsmethode 2",
  },

  // ── Kategorie opłat ───────────────────────────────────────────────────────
  chargeCategories: {
    minibar:    "Minibar",
    lateCharge: "Verspaetungsgebuehr",
    other:      "Andere",
  },

  // ── Etykiety ──────────────────────────────────────────────────────────────
  labels: {
    folio:            "Folio",
    invoice:          "Rechnung",
    fiscalizedInvoice:"Fiskalische Rechnung",
    chargeCategory:   "Gebuehrenkategorie",
    balanceDue:       "Offener Betrag",
    activeFolio:      "Aktives Folio",
    billingCompany:   "Rechnungsfirma",
    noFolioSelected:  "Kein Folio ausgewaehlt",
  },

  // ── Komunikaty ────────────────────────────────────────────────────────────
  messages: {
    adjustmentFailed: "Korrektur fehlgeschlagen.",
    chargeFailed:     "Buchung der Gebuehr fehlgeschlagen.",
    invoiceFailed:    "Rechnungserstellung fehlgeschlagen.",
    refundFailed:     "Rueckerstattung fehlgeschlagen.",
  },

} as const;

export default dePmsBilling;
